export enum IntroGuideRoute {
  CONTACTS = "CONTACTS",
  CONTACT_FILTER_EDIT = "CONTACT_FILTER_EDIT",
}

export enum IntroGuideName {
  SAMPLE = "SAMPLE",
  CONTACTS_MAIN_PAGE = "CONTACTS_MAIN_PAGE",
  CONTACT_GROUPS_MAIN_PAGE = "CONTACT_GROUPS_MAIN_PAGE",
  CONTACT_FILTERS_MAIN_PAGE = "CONTACT_FILTERS_MAIN_PAGE",
  CONTACT_FILTERS_EDIT_MAIN_PAGE = "CONTACT_FILTERS_EDIT_MAIN_PAGE",
}
